import Joi from 'joi';
const BLACKLIST = ['@site', '@generated', '@docusaurus', '~docs', '~blog', '~pages', '~debug'];
export default function plugin(context, { alias, mergeStrategy }) {
    return {
        name: 'docusaurus-plugin-local-resolve',
        configureWebpack() {
            return {
                mergeStrategy,
                resolve: {
                    alias,
                },
            };
        },
    };
}
export const validateOptions = ({ options, validate }) => {
    return validate(Joi.object({
        alias: Joi.object()
            .pattern(Joi.string().invalid(...BLACKLIST), Joi.string())
            .required(),
        mergeStrategy: Joi.object().pattern(Joi.string(), Joi.string()),
    }), options);
};
